import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TrnBedStatusService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'trn_bed_status/list/?';
    private ListRecordByUnitId = webapi + 'trn_bed_status/listByUnit/?';
    private AddRecord = webapi + 'trn_bed_status/create';
    private EditRecord = webapi + 'trn_bed_status/update';
    private GetRecord = webapi + 'trn_bed_status/byid/';
    private DeleteRecord = webapi + 'trn_bed_status/delete/';
    private DeleteByBedId = webapi + 'trn_bed_status/deleteByBedId/';
    private freebedlistword = webapi + 'trn_bed_status/getfreebedlistbyword/';
    private freebedlistroom = webapi + 'trn_bed_status/getfreebedlistbyroom/';
    private occupiedList = webapi + 'trn_bed_status/getoccupiedlist';
    private updateRecord = webapi + 'trn_bed_status/updatebadestatus/';
    private autochargebedallication = webapi + 'trn_bed_status/updatebadestatus/';
    private autochargebedrelease = webapi + 'trn_bed_status/updatebadestatus/';
    private GetOccupiedBedByUnitId = webapi + 'trn_bed_status/get_occupied_list_by_unit/';
    private GetNonOccupiedBedByUnitId = webapi + 'trn_bed_status/get_non_occupied_list_by_unit/';
    private GetUnderMaintenanceBedListByUnitId = webapi + 'trn_bed_status/get_under_maintenance_list_by_unit/';
    private GetMaintainanceBedByUnitId = webapi + 'trn_bed_status/get_maintainance_list_by_unit/';
    private Allbedlistword = webapi + 'trn_bed_status/getAllfreebedlistbyword/';
    private Allbedlistroom = webapi + 'trn_bed_status/getAllbedlistbyroom/';
    private GetBedSummary = webapi + 'trn_bed_status/getbedsummary/';
    private getbedsummaryByUnitId = webapi + 'trn_bed_status/getbedsummaryByUnitId/';

    constructor(
        private http: Http
    ) {
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitid: any): Promise<any> {
        return this.http.get(this.ListRecordByUnitId + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col + '&unitid=' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteByBedId(id: any) {
        return this.http.put(this.DeleteByBedId + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getFreeBedListbyword(wordId: any) {
        return this.http.get(this.freebedlistword + wordId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getFreeBedListbyroomId(roomId: any) {
        return this.http.get(this.freebedlistroom + roomId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getoccupiedListby() {
        return this.http.get(this.occupiedList)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateRecordService(bedid: any, status: any) {
        return this.http.get(this.updateRecord + bedid + '/' + status)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getOccupiedBedByUnitId(unitId: any) {
        return this.http.get(this.GetOccupiedBedByUnitId + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getNonOccupiedBedByUnitId(unitId: any) {
        return this.http.get(this.GetNonOccupiedBedByUnitId + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getUnderMaintenanceBedListByUnitId(unitId: any) {
        return this.http.get(this.GetUnderMaintenanceBedListByUnitId + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getMaintainanceBedByUnitId(unitId: any) {
        return this.http.get(this.GetMaintainanceBedByUnitId + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    //by sachin
    getAllBedListbyword(wordId: any) {
        return this.http.get(this.Allbedlistword + wordId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllBedListbyroomId(roomId: any) {
        return this.http.get(this.Allbedlistroom + roomId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getBedSummary() {
        return this.http.get(this.GetBedSummary)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getBedSummaryByunitId(unitId: any) {
        return this.http.get(this.getbedsummaryByUnitId + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/trn-bed-status/trn-bed-status.service.ts